var _a;
import { __decorate, __metadata, __param } from "tslib";
import { I18nService } from '@/services/i18n-service';
import { inject, injectable } from 'inversify';
let SaveCustomFieldAsPublicActionContribution = class SaveCustomFieldAsPublicActionContribution {
    constructor(_i18nService) {
        this._i18nService = _i18nService;
    }
    registerCustomFieldActions(action) {
        action.registerCustomFieldAction({
            commandId: 'custom-field.save-as-public',
            icon: 'SolidCopy',
            label: this._i18nService.t('customField.actions.copyToPublic'),
            order: 3,
            isEnabled: (context) => {
                return context.isAdmin && !context.isPublicMode;
            },
            isVisible: (context) => {
                return context.isAdmin && !context.isPublicMode;
            },
        });
    }
};
SaveCustomFieldAsPublicActionContribution = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object])
], SaveCustomFieldAsPublicActionContribution);
export { SaveCustomFieldAsPublicActionContribution };
